import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import PieModal from "../PieModal";
import FilterName from "../../../components/Atoms/FilterName";
import styles from "./barGraph.module.scss";

const ApexPieChart = ({
  series,
  categories,
  height,
  selectedFilters,
  groupByColumn,
  EditIcon,
  filter1Name,
  filter2Name,
  setFilter1Name,
  setFilter2Name,
  comparisonMode,
  setSelectedInternalFilters,
  withQuery,
}) => {
  // Labels for the pie chart

  const [Filter1, setFilter1] = useState(filter1Name && filter1Name);
  const [Filter2, setFilter2] = useState(filter2Name && filter2Name);

  const [askQueryModal, setAskQueryModal] = useState(false);
  const [selectedSlice, setSelectedSlice] = useState(null);

  const [chartWidth, setChartWidth] = useState(window.innerWidth);

  useEffect(() => {}, []);

  useEffect(() => {
    setFilter1(filter1Name);
  }, [filter1Name]);

  useEffect(() => {
    setFilter2(filter2Name);
  }, [filter2Name]);

  const [chartOptions, setChartOptions] = useState({
    labels: categories,
    chart: {
      type: "pie",
    },
    legend: {
      position: "right", // Change legend position
    },
  });

  //-----------------------------------------------------------
  useEffect(() => {
    // console.log(chartOptions);
  }, [chartOptions]);

  useEffect(() => {
    setChartOptions((prevOptions) => ({
      labels: categories,
      colors: [
        "#FF6F61",
        "#6B5B95",
        "#88B04B",
        "#F7CAC9",
        "#92A8D1",
        "#955251",
        "#B565A7",
        "#009B77",
        "#DD4124",
        "#45B8AC",
        "#EFC050",
        "#5B5EA6",
        "#9B2335",
        "#DFCFBE",
        "#BC243C",
        "#98B4D4",
        "#C3447A",
        "#BFD641",
        "#7FCDCD",
        "#D65076",
      ],
      chart: {
        type: "pie",
        events: {
          dataPointSelection: (event, chartContext, config) => {
            // Get the index of the clicked slice
            const sliceIndex = config.dataPointIndex;
            // Set the selected slice to show in the modal
            setSelectedSlice(categories[sliceIndex]);
            // Show the modal
            setAskQueryModal(true);
          },
        },
      },
      legend: {
        position: "right", // Change legend position
        offsetX: 15, // Adds space between the chart and the legends
      },
    }));
    //-------------------------
    const handleResize = () => {
      if (window.innerWidth <= 600) {
        setChartWidth(500);
      } else {
        setChartWidth(600);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [categories]);
  //------------------------------------------------------------------
  return (
    <div className={`${styles.pieChartContainer}`}>
      {comparisonMode && (
        <div className={`${styles.comparisonBtnsContainer} row `}>
          <FilterName
            filter={Filter1 && Filter1}
            filterType="normal"
            setFilter1Name={setFilter1}
            setFilter2Name={setFilter2}
            setSelectedInternalFilters={setSelectedInternalFilters}
          />
          <FilterName
            filter={Filter2 && Filter2}
            filterType="comparison"
            setFilter1Name={setFilter1}
            setFilter2Name={setFilter2}
            setSelectedInternalFilters={setSelectedInternalFilters}
          />
        </div>
      )}

      <Chart
        options={chartOptions}
        series={series && series.length && series[0].name && series[0].data}
        type="pie"
        width={chartWidth}
        height={chartOptions.chart.height}
      />

      {askQueryModal ? (
        <PieModal
          setAskQueryModal={setAskQueryModal}
          selectedSlice={selectedSlice}
          selectedFilters={selectedFilters}
          groupByColumn={groupByColumn}
          EditIcon={EditIcon}
          withQuery={withQuery}
        />
      ) : null}
    </div>
  );
};

export default ApexPieChart;
